import TraceService from 'Services/TraceService.js'

// initial state
const state = {
  traceSequences: [],
  activeSequence: null,
  tabIndex: 0
}

const actions = {
  getTrace: ({ commit }, { context, traceReference, isAdvanced }) => {
    return new Promise((resolve, reject) => {
      TraceService.get(context, traceReference, isAdvanced).then(result => {
        commit('setTrace', result.data)
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  traceSelected: ({ commit }, trace) => {
    commit('setActiveSequence', trace)
  },

  tabSelected: ({ commit }, tabIndex) => {
    commit('setTabIndex', tabIndex)
  }
}

// mutations
const mutations = {
  setTrace (state, trace) {
    state = Object.assign(state, trace)
  },

  setActiveSequence (state, traceSequence) {
    state.activeSequence = state.activeSequence === null ? traceSequence : state.activeSequence.key !== traceSequence.key ? traceSequence : null
  },

  setTabIndex (state, tabIndex) {
    state.tabIndex = tabIndex
  }
}

export default {
  state,
  actions,
  mutations
}
